"use strict";
var Observable_1 = require('../../Observable');
var from_1 = require('../../observable/from');
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1143190010/src/~/rxjs/add/observable/from.js
// module id = XL2q
// module chunks = 6